<template>
    <div class="container">
        <el-row :gutter="20">
            <el-col :span="6" class="listBorder">
                <span class="font_1">题目列表</span>
                <el-button type="success" icon="Plus" class="btnStyle" @click="addProblemFlag = false" circle />
                <br>
                <el-row :gutter="20"  v-if="homeworkList">
                    <el-col :span="4" class="problemBorder" v-for="(homework, index) in homeworkList" :key="homework.homeworkId">
                        <el-progress type="circle" :percentage="100" :width="50" :color="(Problem && currentIndex == index) ? '#76EE00' : '#00BFFF'" @click="choseProblem(index)">
                            <span class="percentage-value">{{ index + 1 }}</span>
                        </el-progress>
                    </el-col>
                </el-row>
            </el-col>


            <el-col :span="16" class="listBorder">
                <div v-if="!addProblemFlag">
                    <span class="font_1">添加题目</span>

                    <div class="form-floating formStyle">
                        <textarea class="form-control" placeholder="Leave a comment here" id="content"></textarea>
                        <label for="floatingTextarea">题目内容</label>
                    </div>

                    <div class="form-floating formStyle">
                        <select class="form-select" id="floatingSelect" aria-label="Floating label select example"  v-model="problemType">
                            <option value="1" selected>填空题</option>
                            <option value="2">单选题</option>
                            <option value="3">多选题</option>
                            <option value="4">判断题</option>
                            <option value="5">简答题</option>
                        </select>
                        <label for="floatingSelect">题目类型</label>
                    </div>

                    <!-- 填空题 -->
                    <div v-if="problemType == 1">
                        <div class="form-floating formStyle">
                            <input type="email" class="form-control" id="fillValue" placeholder="name@example.com">
                            <label for="fillValue">填空题答案</label>
                        </div>
                    </div>

                    <!-- 单选题 -->
                    <div v-if="problemType == 2">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="singleValue" type="radio" value="A" aria-label="Radio button for following text input" checked>
                            </div>
                            <input type="text" class="form-control" id ="singleValueA" aria-label="Text input with radio button">
                            </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="singleValue" type="radio" value="B" aria-label="Radio button for following text input">
                            </div>
                            <input type="text" class="form-control" id ="singleValueB" aria-label="Text input with radio button">

                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、
                                <input class="form-check-input mt-0" name="singleValue" type="radio" value="C" aria-label="Radio button for following text input">
                            </div>
                            <input type="text" class="form-control" id ="singleValueC" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、
                                <input class="form-check-input mt-0" name="singleValue" type="radio" value="D" aria-label="Radio button for following text input">
                            </div>
                            <input type="text" class="form-control" id ="singleValueD" aria-label="Text input with radio button">
                        </div>
                    </div>

                     <!-- 多选题 -->
                    <div v-if="problemType == 3">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、<input class="form-check-input mt-0" name="multipleValue" type="checkbox" value="A" aria-label="Checkbox for following text input">
                            </div>
                            <input type="text" class="form-control" id="multipleValueA" aria-label="Text input with checkbox">
                            </div>
                            <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、<input class="form-check-input mt-0" name="multipleValue" type="checkbox" value="B" aria-label="Checkbox for following text input">
                            </div>
                            <input type="text" class="form-control" id="multipleValueB" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、<input class="form-check-input mt-0" name="multipleValue" type="checkbox" value="C" aria-label="Checkbox for following text input">
                            </div>
                            <input type="text" class="form-control" id="multipleValueC" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、<input class="form-check-input mt-0" name="multipleValue" type="checkbox" value="D" aria-label="Checkbox for following text input">
                            </div>
                            <input type="text" class="form-control" id="multipleValueD" aria-label="Text input with checkbox">
                        </div>
                    </div>

                    <!-- 判断题 -->
                    <div v-if="problemType == 4">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="judgeValue" type="radio" value="A" aria-label="Radio button for following text input" checked>
                            </div>
                            <input type="text" class="form-control" id="judgeValueA" aria-label="Text input with radio button">
                            <span class="displayStyle">————————</span>
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="judgeValue" type="radio" value="B" aria-label="Radio button for following text input">
                            </div>
                            <input type="text" class="form-control" id="judgeValueB" aria-label="Text input with radio button">
                        </div>
                    </div>

                    <!-- 简答题 -->
                    <div v-if="problemType == 5">
                        <div class="form-floating formStyle">
                            <textarea class="form-control" placeholder="Leave a comment here" id="shortAnswer"></textarea>
                            <label for="shortAnswer">简答题答案</label>
                        </div>
                    </div>


                    <div class="form-floating formStyle">
                        <input type="number" class="form-control" id="sorts" placeholder="Password" min="1" max="100">
                        <label for="sorts">排序值</label>
                    </div>

                    <div class="form-floating formStyle">
                        <input type="number" class="form-control" id="score" placeholder="Password" min="1" max="100">
                        <label for="score">分值</label>
                    </div>


                    <el-button type="success" icon="Plus" class="btnStyle" @click="addProblem()" plain>添加题目</el-button>
                </div>

                <div v-if="addProblemFlag && Problem">
                    <span class="font_1">题目展示</span>
                    <div class="form-floating formStyle">
                        <textarea class="form-control" placeholder="Leave a comment here" id="editContent" :value="Problem.content"></textarea>
                        <label for="editContent">题目内容</label>
                    </div>

                    <div class="form-floating formStyle">
                        <select class="form-select" id="editFloatingSelect" aria-label="Floating label select example"  v-model="Problem.type">
                            <option value="1" selected>填空题</option>
                            <option value="2">单选题</option>
                            <option value="3">多选题</option>
                            <option value="4">判断题</option>
                            <option value="5">简答题</option>
                        </select>
                        <label for="editFloatingSelect">题目类型</label>
                    </div>

                    <!-- 填空题 -->
                    <div v-if="Problem.type == 1">
                        <div class="form-floating formStyle">
                            <input type="email" class="form-control" id="editFillValue" :value="Problem.rightAnswer" placeholder="name@example.com">
                            <label for="editFillValue">填空题答案</label>
                        </div>
                    </div>

                    <!-- 单选题 -->
                    <div v-if="Problem.type == 2">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="A" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'A'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueA" :value="Problem.answerA" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="B" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'B'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="C" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'C'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueC" :value="Problem.answerC" aria-label="Text input with radio button">
                            </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、
                                <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="D" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'D'">
                            </div>
                            <input type="text" class="form-control" id="editSingleValueD" :value="Problem.answerD" aria-label="Text input with radio button">
                        </div>
                    </div>

                     <!-- 多选题 -->
                    <div v-if="Problem.type == 3">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="A" aria-label="Checkbox for following text input"  v-bind:checked="Problem.rightAnswer.includes('A')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueA" :value="Problem.answerA"  aria-label="Text input with checkbox">
                            </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                B、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="B" aria-label="Checkbox for following text input" v-bind:checked="Problem.rightAnswer.includes('B')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueB" :value="Problem.answerB" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                C、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="C" aria-label="Checkbox for following text input" v-bind:checked="Problem.rightAnswer.includes('C')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueC" :value="Problem.answerC" aria-label="Text input with checkbox">
                        </div>
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                D、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="D" aria-label="Checkbox for following text input" v-bind:checked="Problem.rightAnswer.includes('D')">
                            </div>
                            <input type="text" class="form-control" id="editMultipleValueD" :value="Problem.answerD" aria-label="Text input with checkbox">
                        </div>
                    </div>

                    <!-- 判断题 -->
                    <div v-if="Problem.type == 4">
                        <div class="input-group judgeStyle">
                            <div class="input-group-text">
                                A、
                                <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="A" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'A'">
                            </div>
                            <input type="text" class="form-control" id="editJudgeValueA" :value="Problem.answerA" aria-label="Text input with radio button">
                            <span class="displayStyle">————————</span>
                            <div class="input-group-text">
                                B、
                                <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="B" aria-label="Radio button for following text input" v-bind:checked="Problem.rightAnswer == 'B'">
                            </div>
                            <input type="text" class="form-control" id="editJudgeValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                        </div>
                    </div>

                    <!-- 简答题 -->
                    <div v-if="Problem.type == 5">
                        <div class="form-floating formStyle">
                            <textarea class="form-control" placeholder="Leave a comment here" id="editShortAnswer" :value="Problem.rightAnswer"></textarea>
                            <label for="editShortAnswer">简答题答案</label>
                        </div>
                    </div>


                    <div class="form-floating formStyle">
                        <input type="number" class="form-control" id="editSorts" :value="Problem.sorts" placeholder="Password" min="1" max="100">
                        <label for="editSorts">排序值</label>
                    </div>

                    <div class="form-floating formStyle">
                        <input type="number" class="form-control" id="editScore" :value="Problem.score" placeholder="Password" min="1" max="100">
                        <label for="editScore">分值</label>
                    </div>


                    <el-button type="danger" icon="Delete" class="btnStyle" @click="deleteProblem()"  plain>删除题目</el-button>
                    <el-button type="primary" icon="Edit" class="btnStyle" @click="editProblem()"  plain>修改题目</el-button>
                </div>
            </el-col>
        </el-row>

                


  </div>
</template>

<script setup>

import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";


const courseId = ref();
const homewokrId = ref();

const Route = useRoute(); //获取到值
import router from "@/router/index";
const addProblemFlag = ref(false);
const problemType = ref(1);
const homeworkList = ref();
const Problem = ref();
const currentIndex = ref("");


// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
  // 获取路由参数并设置为 current_page
  courseId.value = Route.params.courseId || '';
  homewokrId.value = Route.params.homeworkId || '';
  preAuth();
  pullProblemList();
});

// 加载题目信息
const pullProblemList = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/problem/getProblemList",
    data: {
        parentId: homewokrId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
            homeworkList.value = resp.data;
        } else {
            ElMessage({
                type: "error",
                message: "拉取题目失败！"
            });
        }
    },
    error() {
        ElMessage({
            type: "error",
            message: "拉取题目失败！"
        });
    },
  });
};


const preAuth = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/problem/hasPreAuth",
    data: {
      examId: homewokrId.value
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        console.log("放行");
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
        router.push({ name: "home" });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "权限不足",
      });
      router.push({ name: "home" });
    },
  });
}


const addProblem = () => {
    let content = $("#content").val();
    if (content == "") {
        ElMessage({
            type: "error",
            message: "题目内容不能为空！"
        });
        return false;
    }

    let sorts = $("#sorts").val();
    if (sorts == "") {
        ElMessage({
            type: "error",
            message: "排序值不能为空！"
        });
        return false;
    }

    let score = $("#score").val();
    if (score == "") {
        ElMessage({
            type: "error",
            message: "分值不能为空！"
        });
        return false;
    }

    let answerA = "";
    let answerB = "";
    let answerC = "";
    let answerD = "";
    let rightAnswer = "";


    if (problemType.value == 1) {
        if ($("#fillValue").val() == "") {
                ElMessage({
                type: "error",
                message: "填空题答案不能为空！"
            });
            return false;
        }
        rightAnswer = $("#fillValue").val();
    }   

    if (problemType.value == 2) {
        if ($("#singleValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#singleValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        if ($("#singleValueC").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案C不能为空！"
            });
            return false;
        }
        if ($("#singleValueD").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案D不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var selectedValue = $('input[name="singleValue"]:checked').val();

        answerA = $("#singleValueA").val();
        answerB = $("#singleValueB").val();
        answerC = $("#singleValueC").val();
        answerD = $("#singleValueD").val();
        rightAnswer = selectedValue;

    }

    if (problemType.value == 3) {
        if ($("#multipleValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#multipleValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        if ($("#multipleValueC").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案C不能为空！"
            });
            return false;
        }
        if ($("#multipleValueD").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案D不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var selectedValuesString = "";

        // 遍历所有被选中的复选框并将值以逗号分割的形式添加到字符串中
        $('input[name="multipleValue"]:checked').each(function(index) {
            // 如果不是第一个值，则在值前加上逗号
            if (index > 0) {
                selectedValuesString += ",";
            }
            selectedValuesString += $(this).val();
        });


        if (selectedValuesString == "") {
            ElMessage({
                type: "error",
                message: "正确选项不能为空！"
            });
            return false;
        }

        answerA = $("#multipleValueA").val();
        answerB = $("#multipleValueB").val();
        answerC = $("#multipleValueC").val();
        answerD = $("#multipleValueD").val();
        rightAnswer = selectedValuesString;
    }

    if (problemType.value == 4) {
        if ($("#judgeValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#judgeValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var judgeValue = $('input[name="judgeValue"]:checked').val();

        answerA = $("#judgeValueA").val();
        answerB = $("#judgeValueB").val();
        rightAnswer = judgeValue;
    }

    if (problemType.value == 5) {
        if ($("#shortAnswer").val() == "") {
                ElMessage({
                type: "error",
                message: "简答题答案不能为空！"
            });
            return false;
        }
        rightAnswer = $("#shortAnswer").val();
    }

    const token = localStorage.getItem("token");

    let homeworkid = homewokrId.value;

    $.ajax({
        url: "http://124.222.105.205:5000/api/problem/addProblem",
        type: "post",
        data: JSON.stringify({
            content: content,
            type: problemType.value,
            answerA: answerA,
            answerB: answerB,
            answerC: answerC,
            answerD: answerD,
            rightAnswer: rightAnswer,
            parentId: homeworkid,
            sorts: sorts,
            score: score,
        }),
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code === "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg
                });
                pullProblemList();
                changeCurrentIndex(resp.data);
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "添加题目失败！"
            });
        }
    });
}

const editProblem = () => {
    let content = $("#editContent").val();
    if (content == "") {
        ElMessage({
            type: "error",
            message: "题目内容不能为空！"
        });
        return false;
    }

    let sorts = $("#editSorts").val();
    if (sorts == "") {
        ElMessage({
            type: "error",
            message: "排序值不能为空！"
        });
        return false;
    }

    let score = $("#editScore").val();
    if (score == "") {
        ElMessage({
            type: "error",
            message: "分值不能为空！"
        });
        return false;
    }

    let answerA = "";
    let answerB = "";
    let answerC = "";
    let answerD = "";
    let rightAnswer = "";


    if (Problem.value.type == 1) {
        if ($("#editFillValue").val() == "") {
                ElMessage({
                type: "error",
                message: "填空题答案不能为空！"
            });
            return false;
        }
        rightAnswer = $("#editFillValue").val();
    }   

    if (Problem.value.type == 2) {
        if ($("#editSingleValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#editSingleValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        if ($("#editSingleValueC").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案C不能为空！"
            });
            return false;
        }
        if ($("#editSingleValueD").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案D不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var selectedValue = $('input[name="editSingleValue"]:checked').val();

        if (selectedValue == null || selectedValue == "") {
            ElMessage({
                type: "error",
                message: "正确选项不能为空！"
            });
            return false;
        }

        answerA = $("#editSingleValueA").val();
        answerB = $("#editSingleValueB").val();
        answerC = $("#editSingleValueC").val();
        answerD = $("#editSingleValueD").val();
        rightAnswer = selectedValue;

    }

    if (Problem.value.type == 3) {
        if ($("#editMultipleValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#editMultipleValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        if ($("#editMultipleValueC").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案C不能为空！"
            });
            return false;
        }
        if ($("#editMultipleValueD").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案D不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var selectedValuesString = "";

        // 遍历所有被选中的复选框并将值以逗号分割的形式添加到字符串中
        $('input[name="editMultipleValue"]:checked').each(function(index) {
            // 如果不是第一个值，则在值前加上逗号
            if (index > 0) {
                selectedValuesString += ",";
            }
            selectedValuesString += $(this).val();
        });


        if (selectedValuesString == "") {
            ElMessage({
                type: "error",
                message: "正确选项不能为空！"
            });
            return false;
        }

        answerA = $("#editMultipleValueA").val();
        answerB = $("#editMultipleValueB").val();
        answerC = $("#editMultipleValueC").val();
        answerD = $("#editMultipleValueD").val();
        rightAnswer = selectedValuesString;
    }

    if (Problem.value.type == 4) {
        if ($("#editJudgeValueA").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案A不能为空！"
            });
            return false;
        }
        if ($("#editJudgeValueB").val() == "") {
                ElMessage({
                type: "error",
                message: "选择答案B不能为空！"
            });
            return false;
        }
        
        // 获取被选中的单选框的值
        var judgeValue = $('input[name="editJudgeValue"]:checked').val();

        if (judgeValue == null || judgeValue == "") {
            ElMessage({
                type: "error",
                message: "正确选项不能为空！"
            });
            return false;
        }


        answerA = $("#editJudgeValueA").val();
        answerB = $("#editJudgeValueB").val();
        rightAnswer = judgeValue;
    }

    if (Problem.value.type == 5) {
        if ($("#editShortAnswer").val() == "") {
                ElMessage({
                type: "error",
                message: "简答题答案不能为空！"
            });
            return false;
        }
        rightAnswer = $("#editShortAnswer").val();
    }

    const token = localStorage.getItem("token");

    let homeworkid = homewokrId.value;

    $.ajax({
        url: "http://124.222.105.205:5000/api/problem/updateProblem",
        type: "post",
        data: JSON.stringify({
            problemId: Problem.value.problemId,
            content: content,
            type: Problem.value.type,
            answerA: answerA,
            answerB: answerB,
            answerC: answerC,
            answerD: answerD,
            rightAnswer: rightAnswer,
            parentId: homeworkid,
            sorts: sorts,
            score: score,
        }),
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code === "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg
                });
                pullProblemList();
                changeCurrentIndex(Problem.value.problemId);
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改题目失败！"
            });
        }
    });
}

const deleteProblem = () => {
    ElMessageBox.confirm("是否删除题目?", "删除题目", {
    confirmButtonText: "退出删除",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        const token = localStorage.getItem("token");

        $.ajax({
            url: "http://124.222.105.205:5000/api/problem/deleteProblem",
            type: "post",
            data: {
                problemId: Problem.value.problemId
            },
            headers: {
                Authorization: "Bearer " + token,
            },
            success(resp) {
                if (resp.code === "200") {
                    ElMessage({
                        type: "success",
                        message: "删除题目成功！"
                    });
                    pullProblemList();
                    if (currentIndex.value != null && currentIndex.value != "") choseProblem(currentIndex.value - 1);
                } else {
                    ElMessage({
                        type: "error",
                        message: "删除题目失败！"
                    });
                }
            },
            error() {
                ElMessage({
                    type: "error",
                    message: "删除题目失败！"
                });
            }
        });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
}

const choseProblem = (index) => {
    addProblemFlag.value = true;
    Problem.value = homeworkList.value[index];
    currentIndex.value = index;
    
}

const changeCurrentIndex = (id) => {
    setTimeout(() => {
        let i = 0;
        for(let problem of homeworkList.value) {
            if (problem.problemId == id) {
                currentIndex.value = i;
            }
            i ++;
        }    
    }, 300);
}
</script>

<style scoped>
.listBorder {
    background-color: rgb(247, 246, 246);
    border-radius: 20px;
    margin: 20px;
    height: 100%;
}

.percentage-value {
  display: block;
  font-size: 20px;
  transition: 300ms;
}

.percentage-value:hover{
  display: block;
  font-size: 28px;
  transition: 500ms;
}

.problemBorder {
    margin: 10px;
}

.problemBorder:hover{
    cursor: pointer;
    width: 40px;
}

.btnStyle {
    float: right;
    margin: 5px;
}

.font_1{
    font-size: 20px;
    font-weight: bold;
    color: rgb(112, 112, 112);
}

.formStyle {
    margin: 10px;
}

.judgeStyle {
    width: 800px;
    padding: 20px;
}

.displayStyle {
    color: rgba(240, 248, 255, 0);
}

</style>